module.exports = __webpack_public_path__ + "img/bullet-primary.b2f2a9af.svg";